import hashCode from "./HashCode";

const defaultColours = [
    'bg-red-300',
    'bg-yellow-300',
    'bg-green-300',
    'bg-blue-300',
    'bg-indigo-300',
    'bg-purple-300',
    'bg-pink-300'
];

// Gets a default colour for a given name. Is stable/idempotent.
// Useful when profiles don't have a picture to give it a splash of colour.
export default function getDefaultColour(name?: string) {
    if (name == undefined)
        return 'gray';

    const hash = hashCode(name);
    return defaultColours[Math.abs(hash % defaultColours.length)];
}
